import React from "react";
import { PointAcopioProvider } from "../Context/PointAcopioContext";
import PointAcopioContent from "./PointAcopio/PointAcopioContent";

const PointAcopio = () => {
  return (
    <PointAcopioProvider>
      <PointAcopioContent />
    </PointAcopioProvider>
  );
};

export default PointAcopio;
